import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectULSearchText = createSelector(
  [(store: RootState) => store.templateList.ulSearchText],
  (data) => data
);
